import { Fragment } from 'react';
import { VStack } from '@chakra-ui/react';
import type { gameResult } from '@/models/gameUpdate';
import { sortGameResultsRecentFirst } from '@/helpers';
import { groupResultsByMatchday } from '@/helpers/fixtures/matchdayGroups';
import { ListSectionHeader } from './ListSectionHeader';
import { MatchResultRow } from './MatchResultRow';

export function MatchdayResultsList(props: {
  results: gameResult[];
  svg?: boolean;
  expandable?: boolean;
  fontSize?: number;
  metaFontSize?: number;
  nameLines?: number;
}) {
  const { results, svg, expandable, fontSize, metaFontSize, nameLines } = props;

  if (results.length === 0) return null;

  const useMatchdayLayout =
    results.length > 0 && results.every((r) => typeof r.matchday === 'number');

  if (!useMatchdayLayout) {
    return (
      <VStack align='stretch' spacing={2} pb={2}>
        {sortGameResultsRecentFirst(results).map((result, index) => (
          <MatchResultRow
            key={`${result.countryA}-${result.countryB}-${index}`}
            result={result}
            svg={svg}
            expandable={expandable}
            fontSize={fontSize}
            metaFontSize={metaFontSize}
            nameLines={nameLines}
          />
        ))}
      </VStack>
    );
  }

  const groups = groupResultsByMatchday(results);

  return (
    <>
      {groups.map((g) => (
        <Fragment key={`md-${g.matchday}`}>
          <ListSectionHeader label={`Matchday ${g.matchday}`} />
          <VStack align='stretch' spacing={2} pt={2} pb={3}>
            {g.results.map((result, index) => (
              <MatchResultRow
                key={`${result.countryA}-${result.countryB}-${index}`}
                result={result}
                svg={svg}
                expandable={expandable}
                fontSize={fontSize}
                metaFontSize={metaFontSize}
                nameLines={nameLines}
              />
            ))}
          </VStack>
        </Fragment>
      ))}
    </>
  );
}
